import ContentfulImageRenderer from '../../contentful/image_renderer';

const EventHero = ({ heroImage }) =>
  !!Object.keys(heroImage).length && (
    <div className="event__hero__banner mb-40">
      <ContentfulImageRenderer image={heroImage} />
    </div>
  );

export default EventHero;
